/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_Ai_Starter_ValueInputs */



/**
* | output |
* | --- |
* | "Pay only for what you use" |
*
* @param {Plan_Card_Ai_Starter_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_ai_starter_value = /** @type {((inputs?: Plan_Card_Ai_Starter_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Ai_Starter_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlen Sie nur, was Sie nutzen")
	return /** @type {LocalizedString} */ ("Pay only for what you use")
});